import React from "react";

import Dropdown from "./Dropdown";

import $ from "jquery";

import Event from "../utils/Event";
import General from "../utils/General";
import Backend from "../utils/Backend";
import Website from "../utils/Website";
import Navigation from "../utils/Navigation";

export default class LinkSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      url: props.url,
      options: [],
      pages: window.PAGES,
      ccPages: window.CC_PAGES,
      collections: window.COLLECTIONS,
      website: window.CURRENT_WEBSITE
    };
  }

  componentDidMount() {
    this.setState({
      options: this._getOptions(),
    });

    this._setPages();

    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps,
      options: this._getOptions(),
    });
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _setPages() {
    Backend.getPages().then((pages) => {
      this.setState({
        pages,
      });
    });
    Backend.getCCPages().then((ccPages) => {
      this.setState({
        ccPages,
      });
    });
    Backend.getProductCategories().then((collections) => {
      this.setState({
        collections,
      });
    })

    this.setState({
      options: this._getOptions(),
    });
  }

  _updateWebsite = General.debounce(
    (website) => {
      this.setState({ website });
      Backend.updateWebsite({
        slug: website.slug,
        extra: website.extra
      });
    },
    1000,
    false
  );

  _setFunnelLink(currentUrl, newOption){
    let {
      type,
      website
    } = this.state

    let ccPageId = null

    if(!website.extra){
      website.extra = {
        ccPageLinks: {
          pages: [],
          menu: [],
          footer: [],
          shop: []
        }
      }
    }


    if(!website.extra.ccPageLinks){
      website.extra.ccPageLinks = {
        pages: [],
        menu: [],
        footer: [],
        shop: []
      }
    }

    let updatedWebsite = Website.removeCCLink(website, type, window.CURRENT_PAGE_ID, [currentUrl])

    if(newOption.className === "ccPages"){
      ccPageId = newOption.referenceId
      const newLink = {
        id: newOption.id,
        url: newOption.value,
        count: 1
      }
      updatedWebsite = Website.addCCLink(updatedWebsite, type, window.CURRENT_PAGE_ID, newLink)
    }

    const pageIds = Website.getCCPageIds(updatedWebsite)

    this._updateWebsite(updatedWebsite)

    Backend.saveLinks({page_ids: pageIds})

    this.props.onUpdated(newOption.value, ccPageId)
  }

  _getBlockOptions() {
    let sections = $(".main-container section");
    let blockOptions = [];
    for (var i = 0; i < sections.length; i++) {
      let section = sections[i];

      let blockNo = parseInt($(section).attr("data-index")) + 1;
      let title = "Block " + blockNo + " | " + $(section).attr("data-name");

      let pageSlug = window.CURRENT_PAGE_SLUG;
      let url;

      if (pageSlug === "index") {
        pageSlug = "";
      }

      if (pageSlug != "") {
        url = `/${pageSlug}#${$(section).attr("id")}`;
      } else {
        url = `/#${$(section).attr("id")}`;
      }

      let blockOption = {
        value: url,
        label: title,
        className: "blockOption",
      };

      blockOptions.push(blockOption);
    }
    return blockOptions;
  }

  _getPageOptions() {
    let { pages } = this.state;
    if (!pages) {
      return [];
    }

    return pages.map((page) => {
      let pageSlug = page.slug;
      if (pageSlug === "index") {
        pageSlug = "";
      }
      return {
        value: `/${pageSlug}`,
        label: page.title,
        className: "blockOption",
      };
    });
  }

  _getPopupOptions() {
    const { website } = this.state
    const popups = website?.extra?.popup_collection || []
    const pagePopups = popups
    return pagePopups.map((popup) => {
      return {
        value: `$#${popup.id}`,
        label: `Popup | ${popup.name}`,
        className: "blockOption",
      };
    });
  }

  _getCCPageOptions(checkoutOnly=false){
    let { ccPages } = this.state;
    if (!ccPages) {
      return [];
    }

    if(checkoutOnly){
      return ccPages.reduce((filtered, ccPage) => {
        let page = ccPage
        if ([4].includes(page.pageType)){
          let option = {
            value: page.url || "",
            label: page.name,
            className: "ccPages",
            referenceId: page.referenceId,
            id: page.id
          }
          filtered.push(option)
        }
        return filtered
      }, [])
    }

    return ccPages.reduce((filtered, ccPage) => {
      let page = ccPage
      if (![3, 5, 6, 36, 38].includes(page.pageType)){
        let option = {
          value: page.url || "",
          label: page.name,
          className: "ccPages",
          referenceId: page.referenceId,
          id: page.id
        }
        filtered.push(option)
      }
      return filtered
    }, [])
  }

  _getCollectionOptions(){
    let { collections } = this.state;
    if (!collections) {
      return [];
    }
    const collectionPageSlug = window.CURRENT_WEBSITE.collection_page_slug || 'shop/collection'

    return collections.map((collection) => {
      return {
        value: `${collectionPageSlug}/${collection.id}`,
        label: collection.title,
        className: "blockOption",
      };
    });
  }

  _getOptions() {

    let checkoutOptions = {
      type: "group",
      name: "Link To Checkout Page",
      items: [
        {
          value: "",
          label: "Select a page",
          className: "ccPages",
          id: null
        },
        ...this._getCCPageOptions(true)
      ],
    }

    let collectionOptions = {
      type: "group",
      name: "Link To Collections",
      items: this._getCollectionOptions(),
    }

    const options = [
      { value: "https://", label: "Link To External / Custom Url" },
      {
        type: "group",
        name: "Link To Block",
        items: this._getBlockOptions(),
      },
      {
        type: "group",
        name: "Link To Storefront Page",
        items: this._getPageOptions(),
      },
      {
        type: "group",
        name: "Link To Funnel Page",
        items: [
          {
            value: "",
            label: "Select a page",
            className: "ccPages",
            id: null
          },
          ...this._getCCPageOptions()
        ],
      },
      collectionOptions,
      {
        type: "group",
        name: "Open Popup",
        items: this._getPopupOptions(),
      },
    ];

    if(this.props.checkoutOnly){
      return [checkoutOptions]
    }

    return options;
  }

  _getSelectedOption(options, value) {
    if (options.length == 0) {
      return null;
    }

    if(this.props.checkoutOnly){
      let funnelPageOptions = options[0]["items"];
      for (var i = 0; i < funnelPageOptions.length; i++) {
        let funnelPageOption = funnelPageOptions[i];
        if (value === funnelPageOption.value) {
          return funnelPageOption;
        }
      }
      return null;
    }

    let blockOptions = options[1]["items"];
    for (var i = 0; i < blockOptions.length; i++) {
      let blockOption = blockOptions[i];
      if (value === blockOption.value) {
        return blockOption;
      }
    }

    let pageOptions = options[2]["items"];
    for (var i = 0; i < pageOptions.length; i++) {
      let pageOption = pageOptions[i];
      if (value === pageOption.value) {
        return pageOption;
      }
    }

    let funnelPageOptions = options[3]["items"];
    for (var i = 0; i < funnelPageOptions.length; i++) {
      let funnelPageOption = funnelPageOptions[i];
      if (value === funnelPageOption.value) {
        return funnelPageOption;
      }
    }

    let collectionOptions = options[4]["items"];
    for (var i = 0; i < collectionOptions.length; i++) {
      let collectionOption = collectionOptions[i];
      if (value === collectionOption.value) {
        return collectionOption;
      }
    }

    let popupOptions = options[5]["items"];
    for (var i = 0; i < popupOptions.length; i++) {
      let popupOption = popupOptions[i];
      if (value === popupOption.value) {
        return popupOption
      }
    }

    return options[0];
  }

  _renderCustomUrl(url, option) {
    if (!option || option.value !== "https://") {
      return null;
    }

    return (
      <div className="mb--1">
        <span>Url</span>
        <input
          type="text"
          defaultValue={url}
          onChange={(event) => {
            this.props.onUpdated(event.target.value);
          }}
        />
        <p>
          To link to an external you must start your url with http:// or https
        </p>
      </div>
    );
  }

  render() {
    let { options, url } = this.state;

    let option = this._getSelectedOption(options, url);
    return (
      <>
        <Dropdown
          options={options}
          value={option}
          onChange={(option) => {
            this._setFunnelLink(url, option)
          }}
          placeholder="Select an option"
        />
        {!url?.startsWith("$#") && this._renderCustomUrl(url, option)}
      </>
    );
  }
}

LinkSelect.defaultProps = {
  checkoutOnly: false,
  type: "pages"
}
